import { getInterfacesOrigin } from "./urls";

export function editInterfaceUrl(projectId: string, pageId?: string) {
  let url = `//${getInterfacesOrigin()}/interfaces`;
  if (pageId) url += `/page/${pageId}`;
  else url += `/project/${projectId}`;

  return url;
}
